
riot.tag2('add-fields-group-edit-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Категория поля</div>\n    </yield>\n    <yield to="body">\n      <loader if="{loader}"></loader>\n      <form if="{!loader}" onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.name}">\n          <label class="control-label">Наименование</label>\n          <input class="form-control" name="name" value="{item.name}">\n          <div class="help-block">{error.name}</div>\n        </div>\n        <div class="form-group">\n          <label class="control-label">Описание</label>\n          <textarea class="form-control" name="description" value="{item.description}" style="resize: none;"></textarea>\n        </div>\n        <div class="form-group">\n          <div class="checkbox-inline">\n            <label>\n              <input name="enabled" type="checkbox" __checked="{parseInt(item.enabled)}" data-bool="1,0">Активный\n            </label>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;

self.on('mount', function () {
    var modal = self.tags['bs-modal'];

    modal.mixin('validation');
    modal.mixin('change');
    modal.item = {
        enabled: 1
    };

    modal.rules = {
        name: 'empty'
    };

    modal.afterChange = function (e) {
        modal.error = modal.validation.validate(modal.item, modal.rules, e.target.name);
    };

    if (opts.id) {
        modal.loader = true;

        API.request({
            object: 'CustomFieldGroup',
            method: 'Info',
            data: { id: opts.id },
            success: function success(response) {
                modal.item = response;
                modal.loader = false;
                modal.update();
            }
        });
    }
});
});


// WEBPACK FOOTER //
// ./pages/settings/add-fields/add-fields-group-edit-modal.tag